import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  collection, getDocs, doc, updateDoc, setDoc,
  query, where, serverTimestamp, writeBatch, getDoc, orderBy
} from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

const SUPERADMIN_UID = 'qMaj1S0UFFQFmxJzYXZzYhEGcUr1';
const SUPERADMIN_EMAIL = 'jandres1cxs@gmail.com';

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;600;700&family=Inter:wght@400;500&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #080810; color: #F5F5F0; font-family: 'Inter', sans-serif; }
  @keyframes spin { to { transform: rotate(360deg); } }
  @keyframes fadeIn { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } }
  @media print {
    body * { visibility: hidden; }
    #report-content, #report-content * { visibility: visible; }
    #report-content { position: absolute; left: 0; top: 0; width: 100%; padding: 20px; background: white; color: black; }
    #report-content .no-print { display: none !important; }
    #report-content button { display: none !important; }
    .no-print { display: none !important; }
  }
`;

const C = { gold: '#F0B429', green: '#06B86A', red: '#E63946', bg: '#080810', card: '#14141f', border: 'rgba(255,255,255,0.07)' };

const FLAG_MAP = {
  MEX:'mx', RSA:'za', KOR:'kr', CAN:'ca', USA:'us', PAR:'py',
  QAT:'qa', SUI:'ch', BRA:'br', MAR:'ma', HAI:'ht', SCO:'gb-sct',
  AUS:'au', GER:'de', CUW:'cw', NED:'nl', JPN:'jp', CIV:'ci',
  ECU:'ec', TUN:'tn', ESP:'es', CPV:'cv', BEL:'be', EGY:'eg',
  KSA:'sa', URU:'uy', IRN:'ir', NZL:'nz', FRA:'fr', SEN:'sn',
  NOR:'no', ARG:'ar', ALG:'dz', AUT:'at', JOR:'jo', POR:'pt',
  ENG:'gb-eng', CRO:'hr', GHA:'gh', PAN:'pa', COL:'co', UZB:'uz',
  TBD: null,
};

function FlagImg({ code, size = 36 }) {
  const iso = FLAG_MAP[code];
  if (!iso) return null;
  return (
    <img
      src={`https://flagcdn.com/w80/${iso}.png`}
      alt=""
      width={size}
      height={Math.round(size * 0.67)}
      style={{ borderRadius: 5, display: 'block', objectFit: 'cover', boxShadow: '0 2px 8px rgba(0,0,0,0.4)' }}
    />
  );
}

const btn = {
  gold: { background: 'linear-gradient(90deg,#F0B429,#C9820A)', border: 'none', borderRadius: 10, padding: '12px 20px', fontFamily: "'Oswald',sans-serif", fontSize: 14, fontWeight: 600, color: '#080810', letterSpacing: 2, cursor: 'pointer' },
  outline: { background: 'transparent', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 10, padding: '8px 14px', fontFamily: "'Oswald',sans-serif", fontSize: 12, color: '#F5F5F0', letterSpacing: 1, cursor: 'pointer' },
  red: { background: 'rgba(230,57,70,0.1)', border: '1px solid rgba(230,57,70,0.2)', borderRadius: 8, padding: '6px 12px', fontFamily: "'Inter',sans-serif", fontSize: 12, color: '#E63946', cursor: 'pointer' },
};

const PHASE_ORDER = ['Grupos','16avos','Octavos','Cuartos','Semifinal','Semifinal Final','Tercer puesto','Final'];

function Toast({ msg, onClose }) {
  useEffect(() => { const t = setTimeout(onClose, 2800); return () => clearTimeout(t); }, []);
  return <div style={{ position: 'fixed', top: 20, left: '50%', transform: 'translateX(-50%)', background: C.green, color: '#fff', padding: '11px 22px', borderRadius: 20, fontFamily: "'Inter',sans-serif", fontSize: 13, fontWeight: 600, zIndex: 300, whiteSpace: 'nowrap', animation: 'fadeIn .3s ease' }}>{msg}</div>;
}

const GROUPS = ['A','B','C','D','E','F','G','H','I','J','K','L'];

const ALL_TEAMS = [
  { code: 'ARG', name: 'Argentina' }, { code: 'AUS', name: 'Australia' },
  { code: 'AUT', name: 'Austria' }, { code: 'BEL', name: 'Bélgica' },
  { code: 'BRA', name: 'Brasil' }, { code: 'CAN', name: 'Canadá' },
  { code: 'COL', name: 'Colombia' }, { code: 'CIV', name: 'Costa de Marfil' },
  { code: 'CPV', name: 'Cabo Verde' }, { code: 'CRO', name: 'Croacia' },
  { code: 'CUW', name: 'Curaçao' }, { code: 'ECU', name: 'Ecuador' },
  { code: 'EGY', name: 'Egipto' }, { code: 'ENG', name: 'Inglaterra' },
  { code: 'ESP', name: 'España' }, { code: 'FRA', name: 'Francia' },
  { code: 'GER', name: 'Alemania' }, { code: 'GHA', name: 'Ghana' },
  { code: 'HAI', name: 'Haití' }, { code: 'IRN', name: 'Irán' },
  { code: 'JOR', name: 'Jordania' }, { code: 'JPN', name: 'Japón' },
  { code: 'KOR', name: 'Corea del Sur' }, { code: 'KSA', name: 'Arabia Saudita' },
  { code: 'MAR', name: 'Marruecos' }, { code: 'MEX', name: 'México' },
  { code: 'NED', name: 'Países Bajos' }, { code: 'NOR', name: 'Noruega' },
  { code: 'NZL', name: 'Nueva Zelanda' }, { code: 'PAN', name: 'Panamá' },
  { code: 'PAR', name: 'Paraguay' }, { code: 'POR', name: 'Portugal' },
  { code: 'QAT', name: 'Qatar' }, { code: 'RSA', name: 'Sudáfrica' },
  { code: 'SCO', name: 'Escocia' }, { code: 'SEN', name: 'Senegal' },
  { code: 'SUI', name: 'Suiza' }, { code: 'TBD', name: '? Por definir' },
  { code: 'TUN', name: 'Túnez' }, { code: 'URU', name: 'Uruguay' },
  { code: 'USA', name: 'Estados Unidos' }, { code: 'UZB', name: 'Uzbekistán' },
  { code: 'ALG', name: 'Argelia' },
  { code: 'CZE', name: 'República Checa' }, { code: 'BIH', name: 'Bosnia-Herzegovina' },
  { code: 'TUR', name: 'Turquía' }, { code: 'SWE', name: 'Suecia' },
  { code: 'IRQ', name: 'Iraq' }, { code: 'CGO', name: 'Congo' },
].sort((a, b) => a.name.localeCompare(b.name));

const PLAN_PRICES = {
  starter: 25000,
  grupo: 50000,
  empresa: 90000,
  grande: 150000,
  masivo: 220000,
};

function normalizeStr(str) {
  if (!str) return '';
  return str.toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

async function calculateSpecialPoints(results, onProgress, fixturesList) {
  onProgress?.('Cargando grupos...');
  const groupsSnap = await getDocs(collection(db, 'groups'));
  const groups = groupsSnap.docs.map(d => ({ id: d.id, ...d.data() }));
  const specialSnap = await getDocs(collection(db, 'specialPredictions'));
  const allSpecial = specialSnap.docs.map(d => ({ id: d.id, ...d.data() }));
  onProgress?.(`Procesando ${allSpecial.length} predicciones especiales...`);

  const teamNameToCode = {};
  ALL_TEAMS.forEach(t => { teamNameToCode[t.name] = t.code; });
  if (fixturesList) {
    fixturesList.forEach(f => {
      if (f.homeTeamName) teamNameToCode[f.homeTeamName] = f.homeTeam || f.homeTeamName;
      if (f.awayTeamName) teamNameToCode[f.awayTeamName] = f.awayTeam || f.awayTeamName;
    });
  }
  teamNameToCode['EE. UU.'] = 'USA';
  teamNameToCode['Estados Unidos'] = 'USA';

  let totalUpdated = 0;
  for (const group of groups) {
    const rules = group.pointRules || {};
    const podioPoints = { champion: rules.champion ?? 15, runnerUp: rules.runnerUp ?? 10, thirdPlace: rules.thirdPlace ?? 8, fourthPlace: rules.fourthPlace ?? 5 };
    const topScorerPoints = rules.topScorer ?? 10;
    const nextRoundPoints = rules.nextRound ?? 3;
    const groupSpecial = allSpecial.filter(s => s.groupId === group.id);

    for (const special of groupSpecial) {
      const preds = special.predictions || {};
      let specialPts = 0;
      const breakdown = [];

      const podioFields = [
        { predKey: 'champion', resultKey: 'champion', pts: podioPoints.champion, label: '🥇 Campeón' },
        { predKey: 'runnerUp', resultKey: 'second', pts: podioPoints.runnerUp, label: '🥈 Subcampeón' },
        { predKey: 'thirdPlace', resultKey: 'third', pts: podioPoints.thirdPlace, label: '🥉 3er puesto' },
        { predKey: 'fourthPlace', resultKey: 'fourth', pts: podioPoints.fourthPlace, label: '4️⃣ 4to puesto' },
      ];

      for (const field of podioFields) {
        const predCode = preds[field.predKey] || '';
        const resultCode = results[field.resultKey] || '';
        if (predCode && resultCode && predCode === resultCode) {
          specialPts += field.pts;
          breakdown.push({ key: field.predKey, label: field.label, pts: field.pts });
        }
      }

      const predScorer = normalizeStr(preds.topScorer);
      const resultScorer = normalizeStr(results.topScorer);
      if (predScorer && resultScorer && predScorer === resultScorer) {
        specialPts += topScorerPoints;
        breakdown.push({ key: 'topScorer', label: '👟 Goleador', pts: topScorerPoints });
      }

      const groupClassified = results.groupClassified || {};
      let groupPts = 0;
      const groupBreakdown = [];

      for (const g of Object.keys(groupClassified)) {
        const classified = groupClassified[g] || [];
        const pred1 = preds[`group${g}_1`] || '';
        const pred2 = preds[`group${g}_2`] || '';
        const pred1Code = teamNameToCode[pred1] || pred1;
        const pred2Code = teamNameToCode[pred2] || pred2;
        if (pred1Code && classified.includes(pred1Code)) {
          groupPts += nextRoundPoints;
          groupBreakdown.push({ key: `group${g}_1`, label: `➡️ Grupo ${g} 1°`, pts: nextRoundPoints });
        }
        if (pred2Code && classified.includes(pred2Code)) {
          groupPts += nextRoundPoints;
          groupBreakdown.push({ key: `group${g}_2`, label: `➡️ Grupo ${g} 2°`, pts: nextRoundPoints });
        }
      }

      specialPts += groupPts;
      breakdown.push(...groupBreakdown);

      try {
        await setDoc(doc(db, 'specialPredictions', special.id), {
          specialPoints: specialPts,
          specialBreakdown: breakdown,
          specialCalculatedAt: serverTimestamp(),
        }, { merge: true });
      } catch(e) { console.error('Error updating specialPredictions:', e); continue; }

      try {
        const memberRef = doc(db, 'groups', group.id, 'members', special.userId);
        const memberSnap = await getDoc(memberRef);
        if (memberSnap.exists()) {
          const m = memberSnap.data();
          const prevSpecial = m.specialPoints || 0;
          const matchPts = m.totalPoints || 0;
          await updateDoc(memberRef, {
            specialPoints: specialPts,
            totalPoints: Math.max(0, matchPts - prevSpecial + specialPts),
            updatedAt: serverTimestamp(),
          });
          totalUpdated++;
        }
      } catch(e) { console.error('Error updating member:', e); }
    }
  }
  onProgress?.(`✓ ${totalUpdated} participantes actualizados`);
  return totalUpdated;
}

export default function SuperAdminPage() {
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();
  const [fixtures, setFixtures] = useState([]);
  const [phaseFilter, setPhaseFilter] = useState('Grupos');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [homeVal, setHomeVal] = useState('');
  const [awayVal, setAwayVal] = useState('');
  const [toast, setToast] = useState(null);
  const [tab, setTab] = useState('partidos');
  const [prizes, setPrizes] = useState({ champion: '', second: '', third: '', fourth: '', topScorer: '', topScorerTeam: '' });
  const [groupClass, setGroupClass] = useState({});
  const [savingPrizes, setSavingPrizes] = useState(false);
  const [savingGroups, setSavingGroups] = useState(false);
  const [calculatingSpecial, setCalculatingSpecial] = useState(false);
  const [stats, setStats] = useState({ groups: 0, predictions: 0 });
  const [payments, setPayments] = useState([]);
  const [loadingPayments, setLoadingPayments] = useState(false);
  const [groupsMap, setGroupsMap] = useState({});
  const [resetUid, setResetUid] = useState('');
  const [resetGroupId, setResetGroupId] = useState('');
  const [resetLoading, setResetLoading] = useState(false);

  // Estados para el informe
  const [reportTab, setReportTab] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [selectedUser, setSelectedUser] = useState('');
  const [groupMembers, setGroupMembers] = useState([]);
  const [userPredictions, setUserPredictions] = useState([]);
  const [loadingReport, setLoadingReport] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [userSpecialBreakdown, setUserSpecialBreakdown] = useState([]);

  // Nuevos estados para simulación
  const [simGroup, setSimGroup] = useState('');
  const [simChampion, setSimChampion] = useState('');
  const [simRunnerUp, setSimRunnerUp] = useState('');
  const [simThird, setSimThird] = useState('');
  const [simFourth, setSimFourth] = useState('');
  const [simTopScorer, setSimTopScorer] = useState('');
  const [simResults, setSimResults] = useState([]);
  const [loadingSim, setLoadingSim] = useState(false);
  const [groupsData, setGroupsData] = useState([]);

  useEffect(() => {
    if (!currentUser) { navigate('/admin-login'); return; }
    const uidValido = currentUser.uid === SUPERADMIN_UID;
    const emailValido = currentUser.email?.toLowerCase().trim() === SUPERADMIN_EMAIL.toLowerCase().trim();
    if (!uidValido || !emailValido) { navigate('/admin'); return; }
    loadData();
  }, [currentUser]);

  useEffect(() => {
    if (tab === 'pagos' && payments.length === 0) loadPayments();
  }, [tab]);

  async function loadData() {
    setLoading(true);
    try {
      const [fixtSnap, groupsSnap, predsSnap, specialSnap] = await Promise.all([
        getDocs(collection(db, 'fixtures')),
        getDocs(collection(db, 'groups')),
        getDocs(collection(db, 'predictions')),
        getDoc(doc(db, 'specialResults', 'mundial2026')),
      ]);
      const list = fixtSnap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => (a.matchNumber || 0) - (b.matchNumber || 0));
      setFixtures(list);
      setStats({ groups: groupsSnap.size, predictions: predsSnap.size });
      const gMap = {};
      const gData = [];
      groupsSnap.docs.forEach(d => {
        gMap[d.id] = d.data().name || d.id;
        gData.push({ id: d.id, ...d.data() });
      });
      setGroupsMap(gMap);
      setGroupsData(gData);
      if (specialSnap.exists()) {
        const data = specialSnap.data();
        setPrizes({
          champion: data.champion || '', second: data.second || '',
          third: data.third || '', fourth: data.fourth || '',
          topScorer: data.topScorer || '', topScorerTeam: data.topScorerTeam || '',
        });
        setGroupClass(data.groupClassified || {});
      }
    } catch (e) { console.error(e); }
    setLoading(false);
  }

  async function loadPayments() {
    setLoadingPayments(true);
    try {
      const snap = await getDocs(query(collection(db, 'payments'), orderBy('createdAt', 'desc')));
      setPayments(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) {
      try {
        const snap2 = await getDocs(collection(db, 'payments'));
        setPayments(snap2.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
      } catch (e2) { console.error(e2); }
    }
    setLoadingPayments(false);
  }

  // ── FUNCIONES DEL INFORME ──
  async function loadGroupMembers(groupId) {
    if (!groupId) return;
    setLoadingReport(true);
    try {
      const membersSnap = await getDocs(collection(db, 'groups', groupId, 'members'));
      const members = membersSnap.docs.map(d => ({
        id: d.id,
        ...d.data(),
        totalPoints: d.data().totalPoints || 0,
        exactPredictions: d.data().exactPredictions || 0,
        correctPredictions: d.data().correctPredictions || 0,
        specialPoints: d.data().specialPoints || 0,
      })).sort((a, b) => (b.totalPoints || 0) - (a.totalPoints || 0));
      setGroupMembers(members);
      setReportTab('participants');
    } catch (e) {
      console.error('Error loading members:', e);
      setToast('❌ Error cargando miembros: ' + e.message);
    }
    setLoadingReport(false);
  }

  async function loadUserPredictions(groupId, userId) {
    if (!groupId || !userId) return;
    setLoadingReport(true);
    try {
      const userDoc = await getDoc(doc(db, 'users', userId));
      if (userDoc.exists()) setUserInfo(userDoc.data());

      const specialPredsSnap = await getDocs(query(
        collection(db, 'specialPredictions'),
        where('groupId', '==', groupId),
        where('userId', '==', userId)
      ));
      if (!specialPredsSnap.empty) {
        const specialData = specialPredsSnap.docs[0].data();
        setUserSpecialBreakdown(specialData.specialBreakdown || []);
      } else {
        setUserSpecialBreakdown([]);
      }

      const predsSnap = await getDocs(query(
        collection(db, 'predictions'),
        where('groupId', '==', groupId),
        where('userId', '==', userId)
      ));
      const predictions = predsSnap.docs.map(d => ({ id: d.id, ...d.data(), fixtureId: d.data().fixtureId }));
      const predsWithFixtures = predictions.map(pred => ({
        ...pred,
        fixture: fixtures.find(f => f.id === pred.fixtureId) || null,
      }));
      predsWithFixtures.sort((a, b) => (a.fixture?.matchNumber || 0) - (b.fixture?.matchNumber || 0));
      
      console.log('🔍 PREDICCIÓN COMPLETA:', predsWithFixtures[0]);
      console.log('🔍 CAMPOS DISPONIBLES:', Object.keys(predsWithFixtures[0] || {}));
      
      setUserPredictions(predsWithFixtures);
      setReportTab('details');
    } catch (e) {
      console.error('Error loading predictions:', e);
      setToast('❌ Error cargando predicciones: ' + e.message);
    }
    setLoadingReport(false);
  }

  // ── FUNCIÓN PARA OBTENER LA PREDICCIÓN DEL USUARIO ──
  function getUserPrediction(pred) {
    let home = '?';
    let away = '?';
    
    // Intentar con diferentes nombres de campos
    if (pred.homePrediction !== undefined && pred.homePrediction !== null && pred.homePrediction !== '') {
      home = pred.homePrediction;
      away = pred.awayPrediction ?? '?';
    } else if (pred.homePred !== undefined && pred.homePred !== null && pred.homePred !== '') {
      home = pred.homePred;
      away = pred.awayPred ?? '?';
    } else if (pred.predHome !== undefined && pred.predHome !== null && pred.predHome !== '') {
      home = pred.predHome;
      away = pred.predAway ?? '?';
    } else if (pred.homeScorePrediction !== undefined && pred.homeScorePrediction !== null && pred.homeScorePrediction !== '') {
      home = pred.homeScorePrediction;
      away = pred.awayScorePrediction ?? '?';
    } else if (pred.prediction && typeof pred.prediction === 'object') {
      home = pred.prediction.home ?? '?';
      away = pred.prediction.away ?? '?';
    } else if (pred.predictedScore && typeof pred.predictedScore === 'object') {
      home = pred.predictedScore.home ?? '?';
      away = pred.predictedScore.away ?? '?';
    } else if (pred.prediction && typeof pred.prediction === 'string') {
      // Intentar parsear string como "1-2" o "1 - 2"
      let parts = pred.prediction.split('-').map(s => s.trim());
      if (parts.length === 2) { 
        home = parts[0]; 
        away = parts[1]; 
      } else {
        parts = pred.prediction.split(' - ').map(s => s.trim());
        if (parts.length === 2) { 
          home = parts[0]; 
          away = parts[1]; 
        }
      }
    } else if (pred.home_goals !== undefined) {
      home = pred.home_goals ?? '?';
      away = pred.away_goals ?? '?';
    } else if (pred.local !== undefined) {
      home = pred.local ?? '?';
      away = pred.visitante ?? '?';
    }
    
    // Si sigue siendo '?', buscar en cualquier campo que contenga "home" o "local"
    if (home === '?' || away === '?') {
      Object.keys(pred).forEach(key => {
        const lowerKey = key.toLowerCase();
        if (lowerKey.includes('home') || lowerKey.includes('local') || lowerKey.includes('pred')) {
          const val = pred[key];
          if (val !== undefined && val !== null && val !== '' && typeof val === 'number') {
            if (home === '?' && (lowerKey.includes('home') || lowerKey.includes('local'))) {
              home = String(val);
            }
          }
        }
        if (lowerKey.includes('away') || lowerKey.includes('visitante') || lowerKey.includes('pred')) {
          const val = pred[key];
          if (val !== undefined && val !== null && val !== '' && typeof val === 'number') {
            if (away === '?' && (lowerKey.includes('away') || lowerKey.includes('visitante'))) {
              away = String(val);
            }
          }
        }
      });
    }
    
    return { home, away };
  }

  // ── EXPORTAR INFORME ──
  function exportReport() {
    if (userPredictions.length === 0) {
      setToast('❌ No hay datos para exportar');
      return null;
    }

    let totalPuntosPartidos = 0, totalAciertos = 0, totalExactos = 0, prediccionesConPuntos = 0;
    userPredictions.forEach(pred => {
      const f = pred.fixture;
      const hasResult = f?.homeScore !== null && f?.homeScore !== undefined;
      if (hasResult && pred.points > 0) {
        totalPuntosPartidos += pred.points || 0;
        totalAciertos++;
        prediccionesConPuntos++;
        if (pred.breakdown?.some(b => b.key === 'exactScore')) totalExactos++;
      }
    });

    let totalPuntosEspeciales = 0;
    if (userSpecialBreakdown && userSpecialBreakdown.length > 0) {
      userSpecialBreakdown.forEach(b => { totalPuntosEspeciales += b.pts || 0; });
    }
    const totalGeneral = totalPuntosPartidos + totalPuntosEspeciales;

    let reportText = `📊 INFORME DE PREDICCIONES\n`;
    reportText += `═══════════════════════════════════\n`;
    reportText += `👤 ${userInfo?.displayName || userInfo?.email || 'Usuario'}\n`;
    reportText += `📊 ${userPredictions.length} predicciones\n`;
    reportText += `⭐ Puntos especiales: ${totalPuntosEspeciales} pts\n`;
    reportText += `🏆 TOTAL GENERAL: ${totalGeneral} pts\n`;
    reportText += `✅ Aciertos en partidos: ${totalAciertos}\n`;
    reportText += `🎯 Exactos: ${totalExactos}\n`;
    reportText += `═══════════════════════════════════\n\n`;

    userPredictions.forEach(pred => {
      const f = pred.fixture;
      const hasResult = f?.homeScore !== null && f?.homeScore !== undefined;
      const isCorrect = pred.points > 0;
      const isExact = pred.breakdown?.some(b => b.key === 'exactScore');
      const { home, away } = getUserPrediction(pred);

      reportText += `📌 #${f?.matchNumber || '?'} · ${f?.phase || '?'} · ${f?.date || '?'}\n`;
      reportText += `   ${f?.homeTeamName || '?'} vs ${f?.awayTeamName || '?'}\n`;
      reportText += `   Resultado: ${hasResult ? `${f.homeScore}-${f.awayScore}` : 'Pendiente'}\n`;
      reportText += `   Tu predicción: ${home}-${away}\n`;
      if (hasResult) {
        reportText += `   ${isCorrect ? `✅ +${pred.points} pts ${isExact ? '🎯' : ''}` : '❌ 0 pts'}\n`;
      } else {
        reportText += `   ⏳ Pendiente\n`;
      }
      if (pred.breakdown && pred.breakdown.length > 0) {
        reportText += `   Desglose: `;
        pred.breakdown.forEach((b, i) => {
          reportText += `${b.label || b.key}: +${b.pts}${i < pred.breakdown.length - 1 ? ', ' : ''}`;
        });
        reportText += `\n`;
      }
      reportText += `\n`;
    });

    reportText += `═══════════════════════════════════\n`;
    reportText += `⭐ PUNTOS ESPECIALES\n`;
    reportText += `═══════════════════════════════════\n`;
    if (userSpecialBreakdown && userSpecialBreakdown.length > 0) {
      userSpecialBreakdown.forEach(b => {
        reportText += `   ${b.label || b.key}: +${b.pts} pts\n`;
      });
      reportText += `\n   SUBTOTAL ESPECIALES: +${totalPuntosEspeciales} pts\n`;
    } else {
      reportText += `   No hay puntos especiales registrados\n`;
    }
    reportText += `\n${'═'.repeat(40)}\n`;
    reportText += `📊 RESUMEN FINAL\n`;
    reportText += `${'═'.repeat(40)}\n`;
    reportText += `🏆 Puntos por partidos: ${totalPuntosPartidos} pts\n`;
    reportText += `⭐ Puntos especiales: ${totalPuntosEspeciales} pts\n`;
    reportText += `📊 TOTAL GENERAL: ${totalGeneral} pts\n`;
    reportText += `✅ Aciertos en partidos: ${totalAciertos}\n`;
    reportText += `🎯 Exactos: ${totalExactos}\n`;
    reportText += `📊 Partidos con puntos: ${prediccionesConPuntos}\n`;

    return reportText;
  }

  function downloadReport() {
    const reportText = exportReport();
    if (!reportText) return;
    const blob = new Blob([reportText], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `informe_${userInfo?.displayName || 'usuario'}_${new Date().toISOString().slice(0,10)}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    setToast('✓ Informe descargado');
  }

  async function copyReport() {
    const reportText = exportReport();
    if (!reportText) return;
    try {
      await navigator.clipboard.writeText(reportText);
      setToast('✓ Informe copiado al portapapeles');
    } catch (e) {
      const textarea = document.createElement('textarea');
      textarea.value = reportText;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setToast('✓ Informe copiado al portapapeles');
    }
  }

  function printReport() {
    window.print();
  }

  // ── FUNCIONES PARA COMPARTIR SIMULACIÓN ──
  function generateSimulationText() {
    if (simResults.length === 0) return null;
    const groupName = groupsData.find(g => g.id === simGroup)?.name || simGroup;
    let text = `🔮 SIMULACIÓN DE RESULTADOS\n`;
    text += `Grupo: ${groupName}\n`;
    text += `───────────────────────────────\n`;
    text += `🥇 Campeón: ${ALL_TEAMS.find(t => t.code === simChampion)?.name || simChampion || '—'}\n`;
    text += `🥈 Subcampeón: ${ALL_TEAMS.find(t => t.code === simRunnerUp)?.name || simRunnerUp || '—'}\n`;
    text += `🥉 3er puesto: ${ALL_TEAMS.find(t => t.code === simThird)?.name || simThird || '—'}\n`;
    text += `4️⃣ 4to puesto: ${ALL_TEAMS.find(t => t.code === simFourth)?.name || simFourth || '—'}\n`;
    text += `👟 Goleador: ${simTopScorer || '—'}\n`;
    text += `───────────────────────────────\n`;
    text += `📊 TABLA DE POSICIONES SIMULADA\n`;
    text += `───────────────────────────────\n`;
    text += `#  Jugador                 Pts actuales  + Simulación  Total\n`;
    text += `───────────────────────────────\n`;
    simResults.forEach((r, idx) => {
      const num = String(idx + 1).padStart(2);
      const name = r.displayName.padEnd(22).substring(0, 22);
      const ptsActuales = String(r.currentTotal).padStart(11);
      const sim = String(`+${r.simSpecial}`).padStart(12);
      const total = String(r.simTotal).padStart(6);
      text += `${num}  ${name} ${ptsActuales} ${sim} ${total}\n`;
    });
    text += `───────────────────────────────\n`;
    text += `* Simulación sin guardar. No afecta los puntos reales.`;
    return text;
  }

  async function copySimulationTable() {
    const text = generateSimulationText();
    if (!text) { setToast('❌ No hay datos de simulación'); return; }
    try {
      await navigator.clipboard.writeText(text);
      setToast('✓ Tabla copiada al portapapeles');
    } catch (e) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setToast('✓ Tabla copiada al portapapeles');
    }
  }

  function downloadSimulationTable() {
    const text = generateSimulationText();
    if (!text) { setToast('❌ No hay datos de simulación'); return; }
    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `simulacion_${new Date().toISOString().slice(0,10)}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    setToast('✓ Simulación descargada');
  }

  function formatDate(dateStr) {
    if (!dateStr) return '—';
    try {
      return new Date(dateStr).toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' });
    } catch { return dateStr; }
  }

  function formatMoney(amount) {
    if (!amount) return '—';
    return `$${Number(amount).toLocaleString('es-CO')}`;
  }

  function montoCoincide(planId, amount) {
    const esperado = PLAN_PRICES[planId];
    if (!esperado || !amount) return null;
    return Math.abs(Number(amount) - esperado) < 500;
  }

  const totalRecaudado = payments.reduce((acc, p) => acc + (Number(p.amount) || 0), 0);

  async function savePrizes() {
    setSavingPrizes(true);
    try {
      await setDoc(doc(db, 'specialResults', 'mundial2026'), {
        ...prizes, groupClassified: groupClass, updatedAt: serverTimestamp()
      }, { merge: true });
      setToast('✓ Premios guardados — calculando puntos...');
    } catch (e) {
      console.error('❌ Error guardando premios:', e);
      setToast('❌ Error Firestore: ' + e.message);
      setSavingPrizes(false);
      return;
    }
    try {
      setCalculatingSpecial(true);
      const updated = await calculateSpecialPoints(
        { ...prizes, groupClassified: groupClass },
        msg => console.log('[Calc]', msg),
        fixtures
      );
      setToast(`✓ Premios guardados · ${updated} participantes actualizados`);
    } catch (e) {
      console.error('❌ Error calculando puntos especiales:', e);
      setToast('⚠️ Guardado OK pero error al calcular: ' + e.message);
    }
    setCalculatingSpecial(false);
    setSavingPrizes(false);
  }

  async function saveGroupClass() {
    setSavingGroups(true);
    try {
      await setDoc(doc(db, 'specialResults', 'mundial2026'), {
        groupClassified: groupClass, updatedAt: serverTimestamp()
      }, { merge: true });
      setToast('✓ Clasificados guardados — calculando puntos...');
    } catch (e) {
      console.error('❌ Error guardando en Firestore:', e);
      setToast('❌ Error Firestore: ' + e.message);
      setSavingGroups(false);
      return;
    }
    try {
      const snap = await getDoc(doc(db, 'specialResults', 'mundial2026'));
      const fullResults = snap.exists() ? snap.data() : { groupClassified: groupClass };
      setCalculatingSpecial(true);
      const updated = await calculateSpecialPoints(fullResults, msg => console.log('[Calc]', msg), fixtures);
      setToast(`✓ Listo · ${updated} participantes actualizados`);
    } catch (e) {
      console.error('❌ Error calculando puntos especiales:', e);
      setToast('⚠️ Guardado OK pero error al calcular: ' + e.message);
    }
    setCalculatingSpecial(false);
    setSavingGroups(false);
  }

  function setGroupTeam(group, pos, code) {
    setGroupClass(prev => {
      const current = prev[group] || ['', ''];
      const updated = [...current];
      updated[pos] = code;
      return { ...prev, [group]: updated };
    });
  }

  function startEdit(fixture) {
    setEditingId(fixture.id);
    setHomeVal(fixture.homeScore !== null && fixture.homeScore !== undefined ? String(fixture.homeScore) : '');
    setAwayVal(fixture.awayScore !== null && fixture.awayScore !== undefined ? String(fixture.awayScore) : '');
  }

  async function saveResult(fixture) {
    if (homeVal === '' || awayVal === '') return;
    const h = parseInt(homeVal);
    const a = parseInt(awayVal);
    setSaving(fixture.id);
    try {
      await updateDoc(doc(db, 'fixtures', fixture.id), {
        homeScore: h, awayScore: a, status: 'finished', updatedAt: serverTimestamp(),
      });
      setFixtures(prev => prev.map(f => f.id === fixture.id ? { ...f, homeScore: h, awayScore: a, status: 'finished' } : f));
      setEditingId(null);
      setToast(`✓ ${fixture.homeTeamName} ${h}-${a} ${fixture.awayTeamName} — calculando puntos...`);
    } catch (e) {
      console.error('❌ Error saveResult:', e);
      setToast('❌ Error: ' + e.message);
    }
    setSaving(null);
  }

  async function clearResult(fixture) {
    setSaving(fixture.id);
    try {
      const predsSnap = await getDocs(query(collection(db, 'predictions'), where('fixtureId', '==', fixture.id)));
      const batch = writeBatch(db);
      const memberDeltas = {};
      for (const predDoc of predsSnap.docs) {
        const pred = predDoc.data();
        if (!pred.groupId || !pred.userId || pred.calculated !== true) continue;
        const key = `${pred.groupId}_${pred.userId}`;
        if (!memberDeltas[key]) {
          memberDeltas[key] = { ref: doc(db, 'groups', pred.groupId, 'members', pred.userId), pts: 0, exact: 0, correct: 0 };
        }
        memberDeltas[key].pts += pred.points || 0;
        memberDeltas[key].exact += pred.breakdown?.some(b => b.key === 'exactScore') ? 1 : 0;
        memberDeltas[key].correct += (pred.points || 0) > 0 ? 1 : 0;
        batch.update(doc(db, 'predictions', predDoc.id), {
          points: 0, calculated: false, breakdown: [], updatedAt: serverTimestamp()
        });
      }
      batch.update(doc(db, 'fixtures', fixture.id), {
        homeScore: null, awayScore: null, status: 'upcoming', updatedAt: serverTimestamp(),
      });
      await batch.commit();
      for (const key of Object.keys(memberDeltas)) {
        const d = memberDeltas[key];
        const snap = await getDoc(d.ref);
        if (snap.exists()) {
          const m = snap.data();
          await updateDoc(d.ref, {
            totalPoints: Math.max(0, (m.totalPoints || 0) - d.pts),
            exactPredictions: Math.max(0, (m.exactPredictions || 0) - d.exact),
            correctPredictions: Math.max(0, (m.correctPredictions || 0) - d.correct),
            updatedAt: serverTimestamp()
          });
        }
      }
      setFixtures(prev => prev.map(f => f.id === fixture.id ? { ...f, homeScore: null, awayScore: null, status: 'upcoming' } : f));
      setToast('✓ Resultado borrado correctamente');
    } catch (e) {
      console.error('❌ Error clearResult:', e);
      setToast('❌ Error: ' + e.message);
    }
    setSaving(null);
  }

  async function resetUserManual() {
    if (!resetUid || !resetGroupId) { setToast('❌ Ingresa UID y GroupID'); return; }
    setResetLoading(true);
    try {
      const memberRef = doc(db, 'groups', resetGroupId, 'members', resetUid);
      const memberSnap = await getDoc(memberRef);
      if (!memberSnap.exists()) { setToast('❌ Usuario no encontrado en ese grupo'); setResetLoading(false); return; }
      await updateDoc(memberRef, { totalPoints: 0, exactPredictions: 0, correctPredictions: 0, specialPoints: 0, updatedAt: serverTimestamp() });
      const predsQuery = query(collection(db, 'predictions'), where('userId', '==', resetUid), where('groupId', '==', resetGroupId));
      const predsSnap = await getDocs(predsQuery);
      const batch = writeBatch(db);
      predsSnap.docs.forEach(predDoc => {
        batch.update(doc(db, 'predictions', predDoc.id), { points: 0, calculated: false, breakdown: [], updatedAt: serverTimestamp() });
      });
      await batch.commit();
      setToast(`✅ Usuario reseteado. ${predsSnap.size} predicciones limpiadas.`);
      setResetUid(''); setResetGroupId('');
    } catch (e) { setToast('❌ Error: ' + e.message); }
    setResetLoading(false);
  }

  // ── RENDERIZAR EL INFORME ──
  function renderReport() {
    return (
      <div id="report-container" style={{ animation: 'fadeIn .2s ease' }}>
        <div style={{ background: 'rgba(240,180,41,0.06)', border: `1px solid rgba(240,180,41,0.15)`, borderRadius: 8, padding: '10px 14px', fontFamily: "'Inter',sans-serif", fontSize: 12, color: C.gold, marginBottom: 16 }}>
          📊 Selecciona un grupo para ver los participantes, luego haz clic en un usuario para ver su informe detallado.
        </div>

        <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
          <select
            value={selectedGroup}
            onChange={e => {
              setSelectedGroup(e.target.value);
              setGroupMembers([]);
              setUserPredictions([]);
              setUserInfo(null);
              setUserSpecialBreakdown([]);
              setReportTab(null);
              if (e.target.value) loadGroupMembers(e.target.value);
            }}
            style={{ flex: 1, padding: '10px 12px', background: '#080810', border: `1px solid ${C.border}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 13 }}
          >
            <option value="">-- Seleccionar grupo --</option>
            {Object.keys(groupsMap).map(id => (
              <option key={id} value={id}>{groupsMap[id]}</option>
            ))}
          </select>
          {reportTab === 'details' && (
            <button onClick={() => {
              setReportTab('participants');
              setUserPredictions([]);
              setUserInfo(null);
              setUserSpecialBreakdown([]);
              setSelectedUser('');
            }} style={{ ...btn.outline, padding: '10px 16px', fontSize: 11 }}>
              ← VOLVER
            </button>
          )}
        </div>

        {loadingReport && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
            <div style={{ width: 36, height: 36, border: `3px solid rgba(255,255,255,0.1)`, borderTop: `3px solid ${C.gold}`, borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
          </div>
        )}

        {!loadingReport && reportTab === 'participants' && groupMembers.length > 0 && (
          <div>
            <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 14, color: C.gold, marginBottom: 12 }}>
              👥 Participantes ({groupMembers.length})
            </div>
            {groupMembers.map(member => (
              <div
                key={member.id}
                onClick={() => {
                  setSelectedUser(member.id);
                  loadUserPredictions(selectedGroup, member.id);
                }}
                style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: '12px 14px', marginBottom: 8, cursor: 'pointer' }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 14, color: '#F5F5F0' }}>
                      {member.displayName || member.email || member.id.slice(0, 8)}
                    </div>
                    <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 10, color: '#6B6B7B' }}>
                      UID: {member.id.slice(0, 12)}...
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 18, color: C.gold }}>
                      {member.totalPoints || 0} pts
                    </div>
                    <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 9, color: '#6B6B7B' }}>
                      ✅ {member.correctPredictions || 0} aciertos
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: 6, display: 'flex', gap: 12, fontFamily: "'Inter',sans-serif", fontSize: 10, color: '#555' }}>
                  <span>🎯 Exactos: {member.exactPredictions || 0}</span>
                  <span>⭐ Especiales: {member.specialPoints || 0}</span>
                </div>
              </div>
            ))}
          </div>
        )}

        {!loadingReport && reportTab === 'details' && userPredictions.length > 0 && (
          <div id="report-content">
            {(() => {
              let totalPuntosPartidos = 0, totalAciertos = 0, totalExactos = 0;
              userPredictions.forEach(pred => {
                const f = pred.fixture;
                const hasResult = f?.homeScore !== null && f?.homeScore !== undefined;
                if (hasResult && pred.points > 0) {
                  totalPuntosPartidos += pred.points || 0;
                  totalAciertos++;
                  if (pred.breakdown?.some(b => b.key === 'exactScore')) totalExactos++;
                }
              });
              let totalPuntosEspeciales = 0;
              if (userSpecialBreakdown && userSpecialBreakdown.length > 0) {
                userSpecialBreakdown.forEach(b => { totalPuntosEspeciales += b.pts || 0; });
              }
              const totalGeneral = totalPuntosPartidos + totalPuntosEspeciales;

              return (
                <>
                  <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: '12px 14px', marginBottom: 16 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                      <div>
                        <div style={{ fontFamily: "'Oswald', sans-serif", fontSize: 16, color: C.gold }}>
                          {userInfo?.displayName || userInfo?.email || 'Usuario'}
                        </div>
                        <div style={{ display: 'flex', gap: 16, marginTop: 6, fontFamily: "'Inter', sans-serif", fontSize: 11, color: '#6B6B7B', flexWrap: 'wrap' }}>
                          <span>📊 {userPredictions.length} predicciones</span>
                          <span>⭐ Especiales: {totalPuntosEspeciales} pts</span>
                          <span>🏆 Total: {totalGeneral} pts</span>
                          <span>✅ Aciertos: {totalAciertos}</span>
                          <span>🎯 Exactos: {totalExactos}</span>
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }} className="no-print">
                        <button onClick={copyReport} style={{ ...btn.outline, padding: '6px 12px', fontSize: 10, borderRadius: 6 }}>
                          📋 Copiar
                        </button>
                        <button onClick={downloadReport} style={{ ...btn.outline, padding: '6px 12px', fontSize: 10, borderRadius: 6 }}>
                          📥 TXT
                        </button>
                        <button onClick={printReport} style={{ ...btn.outline, padding: '6px 12px', fontSize: 10, borderRadius: 6 }}>
                          🖨️ Imprimir
                        </button>
                      </div>
                    </div>
                  </div>

                  <div style={{ fontFamily: "'Oswald', sans-serif", fontSize: 14, color: C.gold, marginBottom: 12 }}>
                    📋 Detalle de predicciones
                  </div>

                  {userPredictions.map(pred => {
                    const f = pred.fixture;
                    const hasResult = f?.homeScore !== null && f?.homeScore !== undefined;
                    const isCorrect = pred.points > 0;
                    const isExact = pred.breakdown?.some(b => b.key === 'exactScore');
                    const { home, away } = getUserPrediction(pred);

                    return (
                      <div
                        key={pred.id}
                        style={{
                          background: C.card,
                          border: `1px solid ${hasResult ? (isCorrect ? 'rgba(6,184,106,0.25)' : 'rgba(230,57,70,0.25)') : C.border}`,
                          borderRadius: 12,
                          padding: '12px 14px',
                          marginBottom: 8
                        }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                          <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 10, color: '#6B6B7B' }}>
                            #{f?.matchNumber || '?'} · {f?.phase || '?'}
                            {f?.date && ` · ${f.date}`}
                          </div>
                          <div style={{ fontFamily: "'Oswald', sans-serif", fontSize: 13, color: isCorrect ? C.green : (hasResult ? C.red : '#555') }}>
                            {hasResult ? (isCorrect ? `+${pred.points} pts` : '0 pts') : '⏳ Pendiente'}
                          </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
                          <div style={{ textAlign: 'center', minWidth: 60 }}>
                            <FlagImg code={f?.homeTeam} size={24} />
                            <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 10, color: '#ddd' }}>
                              {f?.homeTeamName || '?'}
                            </div>
                          </div>
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <span style={{ fontFamily: "'Oswald', sans-serif", fontSize: 16, color: hasResult ? C.gold : '#444' }}>
                                {hasResult ? `${f.homeScore}-${f.awayScore}` : '?-?'}
                              </span>
                              <span style={{ color: '#555', fontFamily: "'Inter', sans-serif", fontSize: 10 }}>|</span>
                              <span style={{ fontFamily: "'Oswald', sans-serif", fontSize: 14, color: '#aaa' }}>
                                {home !== '?' && away !== '?' ? `${home}-${away}` : 'Sin predicción'}
                              </span>
                              {isExact && <span style={{ fontSize: 16 }}>🎯</span>}
                              {isCorrect && !isExact && <span style={{ fontSize: 14 }}>✅</span>}
                            </div>
                            <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 8, color: '#555' }}>
                              {hasResult ? 'Resultado' : ' - '} · Predicción
                            </div>
                          </div>
                          <div style={{ textAlign: 'center', minWidth: 60 }}>
                            <FlagImg code={f?.awayTeam} size={24} />
                            <div style={{ fontFamily: "'Inter', sans-serif", fontSize: 10, color: '#ddd' }}>
                              {f?.awayTeamName || '?'}
                            </div>
                          </div>
                        </div>

                        {pred.breakdown && pred.breakdown.length > 0 && (
                          <div style={{ marginTop: 8, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                            {pred.breakdown.map((b, i) => (
                              <span key={i} style={{
                                background: 'rgba(240,180,41,0.1)',
                                border: '1px solid rgba(240,180,41,0.2)',
                                borderRadius: 12,
                                padding: '2px 8px',
                                fontFamily: "'Inter', sans-serif",
                                fontSize: 8,
                                color: C.gold
                              }}>
                                {b.label || b.key}: +{b.pts}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {userSpecialBreakdown && userSpecialBreakdown.length > 0 && (
                    <div style={{ marginTop: 16 }}>
                      <div style={{ fontFamily: "'Oswald', sans-serif", fontSize: 14, color: C.gold, marginBottom: 12 }}>
                        ⭐ PUNTOS ESPECIALES ({totalPuntosEspeciales} pts)
                      </div>
                      <div style={{ background: C.card, border: `1px solid rgba(240,180,41,0.2)`, borderRadius: 12, padding: '12px 14px' }}>
                        {userSpecialBreakdown.map((b, i) => (
                          <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: i < userSpecialBreakdown.length - 1 ? '1px solid rgba(255,255,255,0.05)' : 'none' }}>
                            <span style={{ fontFamily: "'Inter', sans-serif", fontSize: 12, color: '#ddd' }}>
                              {b.label || b.key}
                            </span>
                            <span style={{ fontFamily: "'Oswald', sans-serif", fontSize: 12, color: C.gold }}>
                              +{b.pts} pts
                            </span>
                          </div>
                        ))}
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0 0 0', borderTop: '2px solid rgba(240,180,41,0.2)', marginTop: 4 }}>
                          <span style={{ fontFamily: "'Oswald', sans-serif", fontSize: 13, color: C.gold }}>
                            SUBTOTAL ESPECIALES
                          </span>
                          <span style={{ fontFamily: "'Oswald', sans-serif", fontSize: 13, color: C.gold }}>
                            +{totalPuntosEspeciales} pts
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              );
            })()}
          </div>
        )}

        {!loadingReport && reportTab === null && selectedGroup && groupMembers.length === 0 && (
          <div style={{ textAlign: 'center', padding: 40, fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6B7B' }}>
            No hay participantes en este grupo
          </div>
        )}
      </div>
    );
  }

  if (loading) return (
    <div style={{ minHeight: '100vh', background: C.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <style>{CSS}</style>
      <div style={{ width: 44, height: 44, border: `4px solid rgba(255,255,255,0.1)`, borderTop: `4px solid ${C.gold}`, borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
    </div>
  );

  const phases = [...new Set(fixtures.map(f => f.phase))].sort((a, b) => PHASE_ORDER.indexOf(a) - PHASE_ORDER.indexOf(b));
  const filtered = fixtures.filter(f => f.phase === phaseFilter);
  const finished = fixtures.filter(f => f.status === 'finished').length;

  return (
    <div style={{ minHeight: '100vh', background: C.bg, maxWidth: 520, margin: '0 auto', padding: '0 0 80px' }}>
      <style>{CSS}</style>
      {toast && <Toast msg={toast} onClose={() => setToast(null)} />}

      <div style={{ background: 'linear-gradient(180deg,#0a0a14,transparent)', padding: '50px 16px 12px', position: 'sticky', top: 0, zIndex: 50 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
          <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 20, fontWeight: 700, letterSpacing: 2 }}>
            ⚡ SUPER<span style={{ color: C.gold }}>ADMIN</span>
          </div>
          <button onClick={() => { logout(); navigate('/'); }} style={{ ...btn.outline, fontSize: 11 }}>SALIR</button>
        </div>
        <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 11, color: '#6B6B7B' }}>
          Panel de resultados globales · Pitazo Mundial 2026
        </div>
      </div>

      <div style={{ padding: '0 16px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 16 }}>
          {[
            { label: 'GRUPOS', value: stats.groups, icon: '👥' },
            { label: 'PREDICCIONES', value: stats.predictions, icon: '⚽' },
            { label: 'JUGADOS', value: `${finished}/104`, icon: '✅' },
          ].map(s => (
            <div key={s.label} style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: '10px 8px', textAlign: 'center' }}>
              <div style={{ fontSize: 18, marginBottom: 2 }}>{s.icon}</div>
              <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 16, color: C.gold }}>{s.value}</div>
              <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 9, color: '#6B6B7B', letterSpacing: 1 }}>{s.label}</div>
            </div>
          ))}
        </div>

        <div style={{ background: 'rgba(240,180,41,0.06)', border: `1px solid rgba(240,180,41,0.15)`, borderRadius: 8, padding: '10px 14px', fontFamily: "'Inter',sans-serif", fontSize: 12, color: C.gold, marginBottom: 14 }}>
          ⚡ Al guardar un resultado aquí, los puntos se calculan automáticamente en <strong>todos los grupos</strong> del sistema.
        </div>

        <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
          {[
            ['partidos', '⚽ Partidos'],
            ['premios', '🏆 Premios'],
            ['grupos', '👥 Clasificados'],
            ['pagos', '💰 Pagos'],
            ['informe', '📊 Informe'],
            ['emergencia', '🚨 Emergencia'],
            ['simulacion', '🔮 Simulación']
          ].map(([key, label]) => (
            <button key={key} onClick={() => {
              setTab(key);
              if (key !== 'informe') {
                setReportTab(null);
                setSelectedGroup('');
                setGroupMembers([]);
                setUserPredictions([]);
                setUserInfo(null);
                setUserSpecialBreakdown([]);
              }
              if (key !== 'simulacion') {
                setSimResults([]);
              }
            }}
              style={{
                flex: 1,
                padding: '8px 4px',
                borderRadius: 10,
                border: 'none',
                cursor: 'pointer',
                fontFamily: "'Oswald',sans-serif",
                fontSize: 10,
                letterSpacing: 1,
                background: tab === key ? C.gold : '#1a1a2a',
                color: tab === key ? '#080810' : '#6B6B7B',
                minWidth: '70px'
              }}>
              {label}
            </button>
          ))}
        </div>

        {/* TAB INFORME */}
        {tab === 'informe' && renderReport()}

        {/* TAB PARTIDOS */}
        {tab === 'partidos' && (
          <>
            <div style={{ display: 'flex', gap: 6, overflowX: 'auto', padding: '4px 0 12px', scrollbarWidth: 'none' }}>
              {phases.map(p => (
                <button key={p} onClick={() => setPhaseFilter(p)}
                  style={{ padding: '5px 12px', borderRadius: 20, border: 'none', cursor: 'pointer', fontFamily: "'Oswald',sans-serif", fontSize: 11, letterSpacing: 1, whiteSpace: 'nowrap', background: phaseFilter === p ? C.gold : '#1a1a2a', color: phaseFilter === p ? '#080810' : '#6B6B7B' }}>
                  {p.toUpperCase()}
                </button>
              ))}
            </div>
            {filtered.map(fixture => {
              const hasResult = fixture.homeScore !== null && fixture.homeScore !== undefined;
              const isEditing = editingId === fixture.id;
              const isSaving = saving === fixture.id;
              return (
                <div key={fixture.id} style={{ background: C.card, border: `1px solid ${hasResult ? 'rgba(6,184,106,0.25)' : C.border}`, borderRadius: 14, padding: '12px 14px', marginBottom: 8, animation: 'fadeIn .2s ease' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                    <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 10, color: '#6B6B7B' }}>
                      #{fixture.matchNumber} · {fixture.date} · {fixture.time}
                    </div>
                    {hasResult && !isEditing && (
                      <div style={{ fontSize: 10, fontFamily: "'Oswald',sans-serif", color: C.green, background: 'rgba(6,184,106,0.1)', padding: '2px 8px', borderRadius: 20 }}>✓ REGISTRADO</div>
                    )}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ flex: 1, textAlign: 'center' }}>
                      <FlagImg code={fixture.homeTeam} size={32} />
                      <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 12, letterSpacing: 1, color: '#ddd', marginTop: 4 }}>{fixture.homeTeamName}</div>
                    </div>
                    {isEditing ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
                        <input type="number" min={0} max={20} value={homeVal} onChange={e => setHomeVal(e.target.value)}
                          style={{ width: 50, height: 44, textAlign: 'center', background: '#080810', border: `2px solid ${C.gold}`, borderRadius: 8, color: C.gold, fontFamily: "'Oswald',sans-serif", fontSize: 22 }} />
                        <span style={{ color: '#555', fontFamily: "'Oswald',sans-serif", fontSize: 20 }}>-</span>
                        <input type="number" min={0} max={20} value={awayVal} onChange={e => setAwayVal(e.target.value)}
                          style={{ width: 50, height: 44, textAlign: 'center', background: '#080810', border: `2px solid ${C.gold}`, borderRadius: 8, color: C.gold, fontFamily: "'Oswald',sans-serif", fontSize: 22 }} />
                      </div>
                    ) : (
                      <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 24, letterSpacing: 3, color: hasResult ? C.green : '#333', minWidth: 80, textAlign: 'center' }}>
                        {hasResult ? `${fixture.homeScore}-${fixture.awayScore}` : '?-?'}
                      </div>
                    )}
                    <div style={{ flex: 1, textAlign: 'center' }}>
                      <FlagImg code={fixture.awayTeam} size={32} />
                      <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 12, letterSpacing: 1, color: '#ddd', marginTop: 4 }}>{fixture.awayTeamName}</div>
                    </div>
                  </div>
                  <div style={{ textAlign: 'center', fontFamily: "'Inter',sans-serif", fontSize: 10, color: '#444', marginTop: 6 }}>
                    {fixture.stadium} · {fixture.city}
                  </div>
                  {isEditing && fixture.phase !== 'Grupos' && (
                    <div style={{ marginTop: 12, background: 'rgba(240,180,41,0.05)', border: '1px solid rgba(240,180,41,0.2)', borderRadius: 10, padding: '10px' }}>
                      <div style={{ fontSize: 10, color: C.gold, fontFamily: "'Oswald',sans-serif", letterSpacing: 1, marginBottom: 8 }}>✏️ EDITAR EQUIPOS</div>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                        {[{ label: 'LOCAL', field: 'home' }, { label: 'VISITANTE', field: 'away' }].map(({ label, field }) => (
                          <div key={field}>
                            <div style={{ fontSize: 9, color: '#6B6B7B', fontFamily: "'Inter',sans-serif", marginBottom: 4 }}>{label}</div>
                            <select
                              defaultValue={field === 'home' ? fixture.homeTeam : fixture.awayTeam || 'TBD'}
                              onChange={async e => {
                                const team = ALL_TEAMS.find(t => t.code === e.target.value);
                                if (!team) return;
                                const updateData = field === 'home'
                                  ? { homeTeam: team.code, homeTeamName: team.name }
                                  : { awayTeam: team.code, awayTeamName: team.name };
                                await updateDoc(doc(db, 'fixtures', fixture.id), { ...updateData, updatedAt: serverTimestamp() });
                                setFixtures(prev => prev.map(f => f.id === fixture.id ? { ...f, ...updateData } : f));
                                setToast(`✓ ${label}: ${team.name}`);
                              }}
                              style={{ width: '100%', padding: '9px 8px', background: '#080810', border: `1px solid ${C.gold}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 12 }}>
                              <option value="TBD">-- Por definir --</option>
                              {ALL_TEAMS.filter(t => t.code !== 'TBD').map(t => <option key={t.code} value={t.code}>{t.name}</option>)}
                            </select>
                            <div style={{ fontSize: 9, color: '#555', marginTop: 3, fontFamily: "'Inter',sans-serif" }}>
                              Actual: {field === 'home' ? fixture.homeTeamName : fixture.awayTeamName}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: 8, marginTop: 10, justifyContent: 'center' }}>
                    {isEditing ? (
                      <>
                        <button onClick={() => saveResult(fixture)} disabled={isSaving || homeVal === '' || awayVal === ''}
                          style={{ ...btn.gold, padding: '9px 24px', fontSize: 13, opacity: (isSaving || homeVal === '' || awayVal === '') ? 0.5 : 1 }}>
                          {isSaving ? 'CALCULANDO...' : '✓ GUARDAR'}
                        </button>
                        <button onClick={() => setEditingId(null)} style={{ ...btn.outline, padding: '9px 16px' }}>CANCELAR</button>
                      </>
                    ) : (
                      <>
                        <button onClick={() => startEdit(fixture)} style={{ ...btn.outline, padding: '7px 18px', fontSize: 11 }}>
                          {hasResult ? '✏️ EDITAR' : '+ RESULTADO'}
                        </button>
                        {hasResult && (
                          <button onClick={() => clearResult(fixture)} disabled={isSaving} style={btn.red}>🗑 BORRAR</button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </>
        )}

        {/* TAB PREMIOS */}
        {tab === 'premios' && (
          <div style={{ animation: 'fadeIn .2s ease' }}>
            <div style={{ background: 'rgba(240,180,41,0.06)', border: `1px solid rgba(240,180,41,0.15)`, borderRadius: 8, padding: '10px 14px', fontFamily: "'Inter',sans-serif", fontSize: 12, color: C.gold, marginBottom: 16 }}>
              🏆 Registra los resultados finales. Al guardar se calculan los puntos especiales de <strong>todos los participantes</strong>.
            </div>
            {[
              { key: 'champion', label: '🥇 Campeón' },
              { key: 'second', label: '🥈 Subcampeón (2do lugar)' },
              { key: 'third', label: '🥉 Tercer lugar' },
              { key: 'fourth', label: '4️⃣ Cuarto lugar' },
            ].map(({ key, label }) => (
              <div key={key} style={{ background: C.card, border: `1px solid ${prizes[key] ? 'rgba(240,180,41,0.3)' : C.border}`, borderRadius: 12, padding: '14px', marginBottom: 10 }}>
                <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 13, letterSpacing: 1, marginBottom: 8, color: prizes[key] ? C.gold : '#888' }}>{label}</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  {prizes[key] && <FlagImg code={prizes[key]} size={28} />}
                  <select value={prizes[key]} onChange={e => setPrizes(p => ({ ...p, [key]: e.target.value }))}
                    style={{ flex: 1, padding: '10px 12px', background: '#080810', border: `1px solid ${C.border}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 13 }}>
                    <option value="">-- Seleccionar equipo --</option>
                    {ALL_TEAMS.map(t => <option key={t.code} value={t.code}>{t.name}</option>)}
                  </select>
                </div>
              </div>
            ))}
            <div style={{ background: C.card, border: `1px solid ${prizes.topScorer ? 'rgba(240,180,41,0.3)' : C.border}`, borderRadius: 12, padding: '14px', marginBottom: 16 }}>
              <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 13, letterSpacing: 1, marginBottom: 8, color: prizes.topScorer ? C.gold : '#888' }}>⚽ Goleador del torneo</div>
              <input value={prizes.topScorer} onChange={e => setPrizes(p => ({ ...p, topScorer: e.target.value }))}
                placeholder="Nombre del goleador (ej: Mbappé)"
                style={{ width: '100%', padding: '10px 12px', background: '#080810', border: `1px solid ${C.border}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 13, marginBottom: 8 }} />
              <div style={{ fontSize: 11, color: '#555', fontFamily: "'Inter',sans-serif", marginBottom: 8 }}>
                💡 Se compara ignorando mayúsculas y acentos. "mbappe" = "Mbappé" ✓
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                {prizes.topScorerTeam && <FlagImg code={prizes.topScorerTeam} size={24} />}
                <select value={prizes.topScorerTeam} onChange={e => setPrizes(p => ({ ...p, topScorerTeam: e.target.value }))}
                  style={{ flex: 1, padding: '10px 12px', background: '#080810', border: `1px solid ${C.border}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 13 }}>
                  <option value="">-- Seleccionar su equipo --</option>
                  {ALL_TEAMS.map(t => <option key={t.code} value={t.code}>{t.name}</option>)}
                </select>
              </div>
            </div>
            <button onClick={savePrizes} disabled={savingPrizes || calculatingSpecial}
              style={{ ...btn.gold, width: '100%', padding: '14px', fontSize: 14, opacity: (savingPrizes || calculatingSpecial) ? 0.6 : 1 }}>
              {calculatingSpecial ? '⏳ CALCULANDO PUNTOS...' : savingPrizes ? 'GUARDANDO...' : '✓ GUARDAR Y CALCULAR PUNTOS'}
            </button>
          </div>
        )}

        {/* TAB CLASIFICADOS */}
        {tab === 'grupos' && (
          <div style={{ animation: 'fadeIn .2s ease' }}>
            <div style={{ background: 'rgba(240,180,41,0.06)', border: `1px solid rgba(240,180,41,0.15)`, borderRadius: 8, padding: '10px 14px', fontFamily: "'Inter',sans-serif", fontSize: 12, color: C.gold, marginBottom: 16 }}>
              👥 Selecciona los 2 equipos clasificados de cada grupo. Solo aparecen los equipos de ese grupo. Al guardar se recalculan los puntos especiales de todos.
            </div>
            {(() => {
              const teamsPerGroup = {};
              GROUPS.forEach(g => { teamsPerGroup[g] = []; });
              fixtures.filter(f => f.phase === 'Grupos').forEach(f => {
                const g = f.group;
                if (!g) return;
                if (!teamsPerGroup[g]) teamsPerGroup[g] = [];
                if (f.homeTeamName && !teamsPerGroup[g].find(t => t.code === f.homeTeam)) {
                  teamsPerGroup[g].push({ code: f.homeTeam || f.homeTeamName, name: f.homeTeamName });
                }
                if (f.awayTeamName && !teamsPerGroup[g].find(t => t.code === f.awayTeam)) {
                  teamsPerGroup[g].push({ code: f.awayTeam || f.awayTeamName, name: f.awayTeamName });
                }
              });
              return GROUPS.map(group => {
                const classified = groupClass[group] || ['', ''];
                const groupTeams = teamsPerGroup[group] || [];
                const teamOptions = groupTeams.length > 0 ? groupTeams : ALL_TEAMS;
                return (
                  <div key={group} style={{ background: C.card, border: `1px solid ${classified[0] && classified[1] ? 'rgba(6,184,106,0.3)' : C.border}`, borderRadius: 12, padding: '12px 14px', marginBottom: 8 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 14, letterSpacing: 2, color: C.gold }}>GRUPO {group}</div>
                        {groupTeams.length > 0 && (
                          <div style={{ fontSize: 9, color: '#555', fontFamily: "'Inter',sans-serif" }}>
                            {groupTeams.length} equipos
                          </div>
                        )}
                      </div>
                      {classified[0] && classified[1] && <div style={{ fontSize: 10, color: C.green, fontFamily: "'Oswald',sans-serif", letterSpacing: 1 }}>✓ COMPLETO</div>}
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      {[0, 1].map(pos => (
                        <div key={pos} style={{ flex: 1 }}>
                          <div style={{ fontSize: 10, color: '#6B6B7B', fontFamily: "'Inter',sans-serif", marginBottom: 4 }}>{pos === 0 ? '1er lugar' : '2do lugar'}</div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            {classified[pos] && <FlagImg code={classified[pos]} size={20} />}
                            <select value={classified[pos]} onChange={e => setGroupTeam(group, pos, e.target.value)}
                              style={{ flex: 1, padding: '8px 6px', background: '#080810', border: `1px solid ${classified[pos] ? 'rgba(240,180,41,0.3)' : C.border}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 11 }}>
                              <option value="">-- Equipo --</option>
                              {teamOptions.map(t => (
                                <option key={t.code} value={t.code}>{t.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              });
            })()}
            <button onClick={saveGroupClass} disabled={savingGroups || calculatingSpecial}
              style={{ ...btn.gold, width: '100%', padding: '14px', fontSize: 14, marginTop: 8, opacity: (savingGroups || calculatingSpecial) ? 0.6 : 1 }}>
              {calculatingSpecial ? '⏳ CALCULANDO PUNTOS...' : savingGroups ? 'GUARDANDO...' : '✓ GUARDAR Y CALCULAR PUNTOS'}
            </button>
          </div>
        )}

        {/* TAB PAGOS */}
        {tab === 'pagos' && (
          <div style={{ animation: 'fadeIn .2s ease' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 14 }}>
              <div style={{ background: C.card, border: `1px solid rgba(6,184,106,0.2)`, borderRadius: 12, padding: '12px', textAlign: 'center' }}>
                <div style={{ fontSize: 20, marginBottom: 2 }}>💰</div>
                <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 18, color: C.green }}>${totalRecaudado.toLocaleString('es-CO')}</div>
                <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 9, color: '#6B6B7B', letterSpacing: 1 }}>TOTAL RECAUDADO</div>
              </div>
              <div style={{ background: C.card, border: `1px solid rgba(240,180,41,0.2)`, borderRadius: 12, padding: '12px', textAlign: 'center' }}>
                <div style={{ fontSize: 20, marginBottom: 2 }}>🧾</div>
                <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 18, color: C.gold }}>{payments.length}</div>
                <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 9, color: '#6B6B7B', letterSpacing: 1 }}>PAGOS REGISTRADOS</div>
              </div>
            </div>
            <button onClick={loadPayments} style={{ ...btn.outline, width: '100%', marginBottom: 14, fontSize: 11 }}>🔄 ACTUALIZAR</button>
            {loadingPayments ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}>
                <div style={{ width: 36, height: 36, border: `3px solid rgba(255,255,255,0.1)`, borderTop: `3px solid ${C.gold}`, borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
              </div>
            ) : payments.length === 0 ? (
              <div style={{ textAlign: 'center', padding: 40, fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#6B6B7B' }}>No hay pagos registrados aún</div>
            ) : payments.map(p => {
              const coincide = montoCoincide(p.planId, p.amount);
              return (
                <div key={p.id} style={{ background: C.card, border: `1px solid ${coincide === false ? 'rgba(230,57,70,0.3)' : coincide === true ? 'rgba(6,184,106,0.25)' : C.border}`, borderRadius: 14, padding: '14px', marginBottom: 10, animation: 'fadeIn .2s ease' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                    <div style={{ background: `linear-gradient(90deg,${C.gold},#C9820A)`, borderRadius: 20, padding: '3px 10px', fontFamily: "'Oswald',sans-serif", fontSize: 11, color: '#080810', letterSpacing: 1, fontWeight: 700 }}>
                      {(p.planName || p.planId || '—').toUpperCase()}
                    </div>
                    <div style={{ fontSize: 11, fontFamily: "'Oswald',sans-serif", color: coincide === false ? C.red : C.green, letterSpacing: 1 }}>
                      {coincide === true ? '✓ MONTO OK' : coincide === false ? '⚠ MONTO DIFF' : ''}
                    </div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
                    {[
                      { label: 'MONTO PAGADO', value: formatMoney(p.amount), highlight: true },
                      { label: 'MONTO ESPERADO', value: PLAN_PRICES[p.planId] ? `$${PLAN_PRICES[p.planId].toLocaleString('es-CO')}` : '—' },
                      { label: 'GRUPO', value: groupsMap[p.groupId] || p.groupId?.slice(0, 8) || '—' },
                      { label: 'PLAN ID', value: p.planId || '—' },
                      { label: 'FECHA', value: formatDate(p.createdAt) },
                      { label: 'ESTADO', value: (p.status || '—').toUpperCase() },
                    ].map(item => (
                      <div key={item.label} style={{ background: '#080810', borderRadius: 8, padding: '8px 10px' }}>
                        <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 9, color: '#6B6B7B', letterSpacing: 1, marginBottom: 2 }}>{item.label}</div>
                        <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 13, color: item.highlight ? C.green : '#F5F5F0' }}>{item.value}</div>
                      </div>
                    ))}
                  </div>
                  <div style={{ marginTop: 8, padding: '6px 10px', background: '#080810', borderRadius: 8 }}>
                    <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 9, color: '#6B6B7B', letterSpacing: 1, marginBottom: 2 }}>PAYMENT ID</div>
                    <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 10, color: '#555', wordBreak: 'break-all' }}>{p.paymentId || p.orderId || '—'}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* TAB EMERGENCIA */}
        {tab === 'emergencia' && (
          <div style={{ animation: 'fadeIn .2s ease' }}>
            <div style={{ background: 'rgba(230,57,70,0.1)', border: '1px solid rgba(230,57,70,0.3)', borderRadius: 8, padding: '12px 14px', marginBottom: 16 }}>
              <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 14, color: '#E63946', marginBottom: 6 }}>🚨 PANEL DE EMERGENCIA</div>
              <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 12, color: '#aaa' }}>
                Usar solo si un usuario quedó con puntos incorrectos que no se pueden borrar desde "Partidos".
              </div>
            </div>
            <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: '14px', marginBottom: 10 }}>
              <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 11, color: '#6B6B7B', marginBottom: 8 }}>UID del usuario (desde Firebase Auth)</div>
              <input placeholder="Ej: qMaj1S0UFFQFmxJzYXZzYhEGcUr1" value={resetUid} onChange={e => setResetUid(e.target.value)}
                style={{ width: '100%', padding: '10px 12px', marginBottom: 12, background: '#080810', border: `1px solid ${C.border}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 13 }} />
              <div style={{ fontFamily: "'Inter',sans-serif", fontSize: 11, color: '#6B6B7B', marginBottom: 8 }}>ID del grupo</div>
              <input placeholder="Ej: abc123def456" value={resetGroupId} onChange={e => setResetGroupId(e.target.value)}
                style={{ width: '100%', padding: '10px 12px', marginBottom: 16, background: '#080810', border: `1px solid ${C.border}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 13 }} />
              <button onClick={resetUserManual} disabled={resetLoading || !resetUid || !resetGroupId}
                style={{ ...btn.red, width: '100%', padding: '14px', fontSize: 14, opacity: (resetLoading || !resetUid || !resetGroupId) ? 0.5 : 1 }}>
                {resetLoading ? 'PROCESANDO...' : '⚠️ RESETEAR USUARIO A 0 PUNTOS'}
              </button>
            </div>
          </div>
        )}

        {/* ─── NUEVA TAB SIMULACIÓN (COMPLETA) ─── */}
        {tab === 'simulacion' && (
          <div style={{ animation: 'fadeIn .2s ease' }}>
            <div style={{ background: 'rgba(240,180,41,0.06)', border: `1px solid rgba(240,180,41,0.15)`, borderRadius: 8, padding: '10px 14px', fontFamily: "'Inter',sans-serif", fontSize: 12, color: C.gold, marginBottom: 16 }}>
              🔮 Elige un grupo y los resultados finales hipotéticos para ver cómo quedaría la tabla. <strong>No modifica nada real.</strong>
            </div>

            <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: '14px', marginBottom: 16 }}>
              <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 13, letterSpacing: 1, marginBottom: 10, color: '#aaa' }}>1. Selecciona el grupo</div>
              <select
                value={simGroup}
                onChange={e => {
                  setSimGroup(e.target.value);
                  setSimResults([]);
                }}
                style={{ width: '100%', padding: '10px 12px', background: '#080810', border: `1px solid ${C.border}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 13, marginBottom: 16 }}
              >
                <option value="">-- Grupo --</option>
                {groupsData.map(g => (
                  <option key={g.id} value={g.id}>{g.name || g.id}</option>
                ))}
              </select>

              <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 13, letterSpacing: 1, marginBottom: 10, color: '#aaa' }}>2. Define los resultados simulados</div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <div>
                  <div style={{ fontSize: 10, color: '#6B6B7B', fontFamily: "'Inter',sans-serif", marginBottom: 4 }}>🥇 Campeón</div>
                  <select value={simChampion} onChange={e => setSimChampion(e.target.value)}
                    style={{ width: '100%', padding: '8px 6px', background: '#080810', border: `1px solid ${C.border}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 12 }}>
                    <option value="">-- Equipo --</option>
                    {ALL_TEAMS.map(t => <option key={t.code} value={t.code}>{t.name}</option>)}
                  </select>
                </div>
                <div>
                  <div style={{ fontSize: 10, color: '#6B6B7B', fontFamily: "'Inter',sans-serif", marginBottom: 4 }}>🥈 Subcampeón</div>
                  <select value={simRunnerUp} onChange={e => setSimRunnerUp(e.target.value)}
                    style={{ width: '100%', padding: '8px 6px', background: '#080810', border: `1px solid ${C.border}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 12 }}>
                    <option value="">-- Equipo --</option>
                    {ALL_TEAMS.map(t => <option key={t.code} value={t.code}>{t.name}</option>)}
                  </select>
                </div>
                <div>
                  <div style={{ fontSize: 10, color: '#6B6B7B', fontFamily: "'Inter',sans-serif", marginBottom: 4 }}>🥉 3er puesto</div>
                  <select value={simThird} onChange={e => setSimThird(e.target.value)}
                    style={{ width: '100%', padding: '8px 6px', background: '#080810', border: `1px solid ${C.border}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 12 }}>
                    <option value="">-- Equipo --</option>
                    {ALL_TEAMS.map(t => <option key={t.code} value={t.code}>{t.name}</option>)}
                  </select>
                </div>
                <div>
                  <div style={{ fontSize: 10, color: '#6B6B7B', fontFamily: "'Inter',sans-serif", marginBottom: 4 }}>4️⃣ 4to puesto</div>
                  <select value={simFourth} onChange={e => setSimFourth(e.target.value)}
                    style={{ width: '100%', padding: '8px 6px', background: '#080810', border: `1px solid ${C.border}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 12 }}>
                    <option value="">-- Equipo --</option>
                    {ALL_TEAMS.map(t => <option key={t.code} value={t.code}>{t.name}</option>)}
                  </select>
                </div>
              </div>

              <div style={{ marginTop: 12 }}>
                <div style={{ fontSize: 10, color: '#6B6B7B', fontFamily: "'Inter',sans-serif", marginBottom: 4 }}>👟 Goleador (nombre)</div>
                <input
                  value={simTopScorer}
                  onChange={e => setSimTopScorer(e.target.value)}
                  placeholder="Ej: Mbappé"
                  style={{ width: '100%', padding: '10px 12px', background: '#080810', border: `1px solid ${C.border}`, borderRadius: 8, color: '#F5F5F0', fontFamily: "'Inter',sans-serif", fontSize: 13 }}
                />
              </div>

              <button
                onClick={async () => {
                  if (!simGroup) { setToast('Selecciona un grupo'); return; }
                  setLoadingSim(true);
                  try {
                    const groupRef = doc(db, 'groups', simGroup);
                    const groupSnap = await getDoc(groupRef);
                    if (!groupSnap.exists()) { setToast('Grupo no encontrado'); setLoadingSim(false); return; }
                    const groupData = groupSnap.data();
                    const rules = groupData.pointRules || {};
                    const championPts = rules.champion ?? 15;
                    const runnerUpPts = rules.runnerUp ?? 10;
                    const thirdPts = rules.thirdPlace ?? 8;
                    const fourthPts = rules.fourthPlace ?? 5;
                    const topScorerPts = rules.topScorer ?? 10;

                    const membersSnap = await getDocs(collection(db, 'groups', simGroup, 'members'));
                    const members = membersSnap.docs.map(d => ({ id: d.id, ...d.data() }));

                    // Obtener nombres de usuario si no están en el documento del miembro
                    const membersWithNames = await Promise.all(members.map(async (member) => {
                      let name = member.displayName || member.name || '';
                      if (!name) {
                        try {
                          const userDoc = await getDoc(doc(db, 'users', member.id));
                          if (userDoc.exists()) {
                            const userData = userDoc.data();
                            name = userData.displayName || userData.email || '';
                          }
                        } catch (e) { /* ignorar */ }
                      }
                      return { ...member, displayName: name || member.email || member.id };
                    }));

                    const specialSnap = await getDocs(query(collection(db, 'specialPredictions'), where('groupId', '==', simGroup)));
                    const specials = {};
                    specialSnap.docs.forEach(d => {
                      const data = d.data();
                      specials[data.userId] = data.predictions || {};
                    });

                    const results = membersWithNames.map(member => {
                      const pred = specials[member.id] || {};
                      let simSpecial = 0;
                      const breakdown = [];

                      if (pred.champion && simChampion && pred.champion === simChampion) {
                        simSpecial += championPts;
                        breakdown.push({ label: '🥇 Campeón', pts: championPts });
                      }
                      if (pred.runnerUp && simRunnerUp && pred.runnerUp === simRunnerUp) {
                        simSpecial += runnerUpPts;
                        breakdown.push({ label: '🥈 Subcampeón', pts: runnerUpPts });
                      }
                      if (pred.thirdPlace && simThird && pred.thirdPlace === simThird) {
                        simSpecial += thirdPts;
                        breakdown.push({ label: '🥉 3er puesto', pts: thirdPts });
                      }
                      if (pred.fourthPlace && simFourth && pred.fourthPlace === simFourth) {
                        simSpecial += fourthPts;
                        breakdown.push({ label: '4️⃣ 4to puesto', pts: fourthPts });
                      }

                      const predTopScorer = normalizeStr(pred.topScorer || '');
                      const simTopScorerNorm = normalizeStr(simTopScorer);
                      if (predTopScorer && simTopScorerNorm && predTopScorer === simTopScorerNorm) {
                        simSpecial += topScorerPts;
                        breakdown.push({ label: '👟 Goleador', pts: topScorerPts });
                      }

                      const currentTotal = member.totalPoints || 0;
                      const simTotal = currentTotal + simSpecial;

                      return {
                        id: member.id,
                        displayName: member.displayName,
                        currentTotal,
                        simSpecial,
                        simTotal,
                        breakdown,
                      };
                    });

                    results.sort((a, b) => b.simTotal - a.simTotal);
                    setSimResults(results);
                    setToast(`Simulación lista para ${groupData.name || simGroup}`);
                  } catch (e) {
                    console.error(e);
                    setToast('Error: ' + e.message);
                  }
                  setLoadingSim(false);
                }}
                disabled={loadingSim}
                style={{ ...btn.gold, width: '100%', padding: '14px', fontSize: 14, marginTop: 20, opacity: loadingSim ? 0.6 : 1 }}
              >
                {loadingSim ? 'CALCULANDO...' : '🔮 CALCULAR SIMULACIÓN'}
              </button>
            </div>

            {/* Resultados de la simulación con botones para compartir */}
            {simResults.length > 0 && (
              <div style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 14, padding: '16px', animation: 'fadeIn .2s ease' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                  <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 16, color: C.gold, letterSpacing: 1 }}>
                    📊 Tabla simulada
                  </div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button onClick={copySimulationTable} style={{ ...btn.outline, padding: '6px 12px', fontSize: 10, borderRadius: 6 }}>
                      📋 Copiar
                    </button>
                    <button onClick={downloadSimulationTable} style={{ ...btn.outline, padding: '6px 12px', fontSize: 10, borderRadius: 6 }}>
                      📥 TXT
                    </button>
                  </div>
                </div>

                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: "'Inter',sans-serif", fontSize: 11 }}>
                    <thead>
                      <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                        <th style={{ padding: '6px 4px', textAlign: 'left', color: '#6B6B7B', fontSize: 10 }}>#</th>
                        <th style={{ padding: '6px 4px', textAlign: 'left', color: '#6B6B7B', fontSize: 10 }}>Jugador</th>
                        <th style={{ padding: '6px 4px', textAlign: 'center', color: '#6B6B7B', fontSize: 10 }}>Pts actuales</th>
                        <th style={{ padding: '6px 4px', textAlign: 'center', color: '#6B6B7B', fontSize: 10 }}>+ Simulación</th>
                        <th style={{ padding: '6px 4px', textAlign: 'center', color: C.gold, fontSize: 10 }}>Total simulado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {simResults.map((r, idx) => (
                        <tr key={r.id} style={{ borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
                          <td style={{ padding: '8px 4px', color: '#aaa' }}>{idx + 1}</td>
                          <td style={{ padding: '8px 4px', color: '#F5F5F0' }}>{r.displayName}</td>
                          <td style={{ padding: '8px 4px', textAlign: 'center', color: C.green }}>{r.currentTotal}</td>
                          <td style={{ padding: '8px 4px', textAlign: 'center', color: C.gold }}>+{r.simSpecial}</td>
                          <td style={{ padding: '8px 4px', textAlign: 'center', fontWeight: 600, color: C.gold }}>{r.simTotal}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div style={{ marginTop: 12, fontSize: 10, color: '#555', fontFamily: "'Inter',sans-serif" }}>
                  * Total simulado = Puntos actuales reales + Puntos que ganaría con los resultados simulados.
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}